import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';
import { OrgService } from 'src/app/service/org.service';
import { CoursesService } from 'src/app/service/courses.service';
import { AttendanceService } from 'src/app/service/attendance.service';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
@Component({
  selector: 'app-available-dates-create',
  templateUrl: './available-dates-create.component.html',
  styleUrls: ['./available-dates-create.component.scss']
})
export class AvailableDatesCreateComponent implements OnInit {

  yearId:any;
  semesterId:any;
  gradeId:any;
  createRecord:any={};
  showLoader: boolean = false;
  creating: boolean = false;
  ShowFilter = true;

  avaRoles: any;
  allIsps: any;

  courses:any=[];
  groups:any=[];

  createAvailableDate = new FormGroup({
    date: new FormControl('', [
      Validators.required,
    ]),
    datetimeFrom: new FormControl('', [
      Validators.required,
    ]),
    datetimeTo: new FormControl('', [
      Validators.required,
    ]),
    status: new FormControl('', [
      // Validators.required,
    ]),
    remarks: new FormControl('', [
      // Validators.required,
    ]),
    group: new FormControl('', [
      Validators.required,
    ]),
    course: new FormControl('', [
      Validators.required,
    ])
    
    
  }, );

  constructor(
    private attendance: AttendanceService,
    private enrollmentGroupService: EnrollmentGroupService,
    private attendanceService:AttendanceService,
    // private userService: UserService,
    //  private ispService: IspService,
    private toastrService: ToastrService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private coursesService: CoursesService
    , private roleService: RoleService
    , private orgService: OrgService
  ) {

  }

  // changeRole(e: any) {
  //   this.createAvailableDate.value.roleType = e.target.value, {
  //     onlySelf: true
  //   }
  // }
  ngOnInit(): void {
   this.getAllCourses();
   this.activatedRoute
   .queryParams
   .subscribe(params => {
     this.yearId = params['yearId'] || "";
     this.semesterId = params['semesterId'] || "";
     this.gradeId = params['gradeId'] || "";

     if (this.yearId == "" || this.semesterId == "" ||this.gradeId == "") {
       
       this.toastrService.warning(this.translate.instant('CAN_NOT_GET_SCHEDULE'));
       this.router.navigate(['/schedule/schedule']);
     }
   });
  }
  getAllCourses() {
    // this.showLoader = true;
    this.coursesService.getAllCourses()
      .subscribe(
        data => {
          this.courses = data;
          this.getGroups();
        }
      );
  }

    getGroups() {
    this.enrollmentGroupService.getAllGroups()
      .subscribe(
        data => {
          this.groups = data;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }
  createAvailableDateChange() {
    // let classHours = this.createAvailableDate.controls.classHours.value;
    // let clinicalHours = this.createAvailableDate.controls.clinicalHours.value;
    // this.createAvailableDate.controls.totalHours.setValue(Number(classHours) + Number(clinicalHours));
  }

  createAvailableDateSubmit() {
    console.log("heree");
    if (this.createAvailableDate.valid) {
      this.creating=true;
      this.createRecord.statusFlag="PENDING";
      this.createRecord.orgid=this.globals.orgId;
      this.createRecord.yearid=this.yearId;
      this.createRecord.semesterid=this.semesterId;
      this.createRecord.gradeid=this.gradeId;
      this.createRecord.groupid=this.createAvailableDate.controls.group.value;
      this.createRecord.subjectid=this.createAvailableDate.controls.course.value;
      this.createRecord.daydate=this.createAvailableDate.controls.date.value;
      this.createRecord.schTimeFrom=this.createAvailableDate.controls.datetimeFrom.value;
      this.createRecord.schTimeTo=this.createAvailableDate.controls.datetimeTo.value;
      this.createRecord.remarks=this.createAvailableDate.controls.remarks.value;
      this.createRecord.active=this.createAvailableDate.controls.status.value;
      let username=this.globals.currentUserInfo.username;
      this.attendance.AddDateSh(username,this.createRecord)
      .subscribe(
        data => {
          if (data.sts == "SUCCESS") {
          if (this.globals.lang == "ar") {
            this.toastrService.success(data.arMsg);
          } else {
            this.toastrService.success(data.enMsg);
          }
        }else{
          if (this.globals.lang == "ar") {
            this.toastrService.error(data.arMsg);
          } else {
            this.toastrService.error(data.enMsg);
          }
        }
        this.creating=false;
        },
        () => {
          this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
          this.creating=false;
        }
      );

    } else {
      this.createAvailableDate.markAllAsTouched();
      this.createAvailableDate.markAsDirty();
    }
  }

  

  addAttendanceType(code: string, nameAr: string, nameEn: string, active: string,elFactor:any) {
    this.creating = true;
    let username = this.globals.currentUserInfo.username;

    this.attendanceService.addAttendanceType(username, 10, code, nameAr, nameEn, active,elFactor)
      .subscribe(
        data => {
          console.log(data);
          if (data.sts == "SUCCESS") {
            this.creating = false;
            this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
            this.router.navigate(['/attendence/type']);
          } else {
            this.creating = false;
            this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
          }
        },
        error => {
          this.creating = false;
          this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
        }
      );
  }
 



  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }
  changegender(){

  }

}
